module.exports = __webpack_public_path__ + "img/15.1706e773.png";